<div class="container">
  <app-general-header [title]="'LMS Courses'" />
  <div class="card border-0 p-3">
    <app-settings-nav [districtCode]="districtCode" />
    <div class="row d-flex justify-content-between my-3 px-xl-5">
      <div class="col-12 col-md-4 order-2 order-md-1">
        <div class="table-search">
          <input
            #searchText
            type="search"
            class="form-control"
            placeholder="Search Courses"
            aria-label="Search Courses"
            (input)="searchTermChanged($event)" />
        </div>
      </div>
      <div
        class="d-flex col-12 col-md-8 order-1 order-md-2 justify-content-center justify-content-md-end my-3 my-md-0">
        <button
          [disabled]="isCreating"
          class="btn btn-primary px-4"
          (click)="showingCreateModal = true">
          <ng-container *ngIf="isCreating">
            <div class="spinner-border spinner-border-sm" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </ng-container>
          <i class="bi bi-plus"></i> Create Course
        </button>
      </div>
    </div>
    <ng-container *ngIf="!isLoading; else loadingTemplate">
      <div class="table-wrapper w-100 mt-3 px-xl-5">
        <table
          *ngIf="courses && courses.length > 0; else noResults"
          class="table gl-striped-table my-4">
          <!--TABLE HEADER-->
          <thead>
            <tr class="align-middle">
              <th scope="col">Title</th>
              <th class="no-wrap" scope="col">Owner</th>
              <th class="no-wrap" scope="col">Status</th>
              <th class="no-wrap" scope="col">Created</th>
              <th class="no-wrap" scope="col">Activity</th>
              <th class="np-wrap" scope="col"></th>
            </tr>
          </thead>
          <!--TABLE BODY-->
          <tbody>
            <tr *ngFor="let course of courses" class="align-middle">
              <td>
                <span class="fw-600 color-primary">{{ course.title }}</span>
              </td>
              <td>
                {{ course.district?.title }}
              </td>
              <td>
                {{ course.status.toLowerCase() }}
              </td>
              <td>
                {{ course.created_at | formatDate }}
              </td>
              <td class="registration-col">
                <ng-container
                  *ngIf="
                    course.registrationCount && course.registrationCount > 0;
                    else noRegistrationBlock
                  ">
                  <button
                    ngbTooltip="View registrations"
                    class="btn btn-link color-tertiary p-0"
                    (click)="showRegistrationsModal(course.id)">
                    {{ course.registrationCount }} registrations
                  </button>
                </ng-container>
                <ng-container
                  *ngIf="
                    course.sessionCount && course.sessionCount > 0;
                    else noSessionsBlock
                  ">
                  <div>{{ course.sessionCount }} sessions</div>
                </ng-container>
                <ng-template #noRegistrationBlock
                  ><div class="no-wrap">0 registrations</div></ng-template
                >
                <ng-template #noSessionsBlock
                  ><div class="no-wrap">0 sessions</div></ng-template
                >
              </td>
              <td class="edit-col">
                <a
                  *ngIf="course.preview_link"
                  ngbTooltip="Preview"
                  href="{{ course.preview_link }}"
                  target="_blank"
                  class="btn btn-link color-tertiary p-1">
                  <i class="bi bi-eye me-2"></i>
                </a>
                <button
                  ngbTooltip="Edit"
                  (click)="showEditModal(course.id)"
                  class="btn btn-link color-tertiary p-1">
                  <i id="edit-{{ course.title }}" class="bi bi-pencil"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <section>
        <div class="d-flex justify-content-center">
          <ngb-pagination
            *ngIf="pagination && pagination.totalCount > 10"
            [(page)]="pagination.currentPage"
            [pageSize]="pagination.perPage"
            [collectionSize]="pagination.totalCount"
            [maxSize]="5"
            (pageChange)="pageChange($event)"></ngb-pagination>
        </div>
      </section>
      <ng-template #noResults>
        <div
          class="w-100 p-5 text-center d-flex justify-content-center align-items-center"
          style="min-height: 300px">
          <div class="xtext-center xtext-body-secondary">
            <p *ngIf="district && district.id === 2">No courses created yet</p>
            <p *ngIf="!district || district.id != 2">
              There are no matching courses associated with your district.
            </p>
          </div>
        </div>
      </ng-template>
      <app-lms-course-create-modal
        *ngIf="showingCreateModal"
        (modalReset)="hideCreateModal()"
        (courseCreated)="showEditModal($event)" />
      <app-lms-course-registrations-modal
        *ngIf="selectedCourseId && showingRegistrationModal"
        [courseId]="selectedCourseId"
        (modalReset)="hideRegistrationModal()" />
      <app-lms-course-edit-modal
        *ngIf="selectedCourseId && showingEditModal"
        [courseId]="selectedCourseId"
        (modalReset)="hideEditModal()" />
    </ng-container>
    <ng-template #loadingTemplate>
      <div style="clear: both; height: 300px"></div>
      <app-loader [top]="200" />
    </ng-template>
  </div>
</div>
